import React from "react";
import { Wrapper } from ".";
import { Row, Col, Form } from "antd";
import { Action, CSelect, CSelectPropertyMenus } from "components";
import { useTranslation } from "react-i18next";
import { useOverview } from "providers/overview";

const SearchOverview = () => {
  const { t } = useTranslation();
  const { form } = useOverview();

  const property = Form.useWatch("property");

  return (
    <Wrapper className="!pb-0">
      <Row gutter={[12, 0]}>
        <Col span={20}>
          <Row gutter={[12, 0]}>
            <Col span={24}>
              <Form.Item label={t("property")} name="property">
                <CSelect.Property
                  placeholder={t("property")}
                  overview
                  bordered={false}
                  allowClear
                  onChange={(v) => {
                    if (!v) {
                      form.setFieldValue("menu", undefined);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t("menu")} name="menu">
                <CSelectPropertyMenus
                  placeholder={t("menu")}
                  multipleMode={true}
                  bordered={false}
                  haveProperty={!!property}
                  filterOption={(value, option) => {
                    const filterSearch = !!option?.label
                      ?.toString()
                      ?.toLowerCase()
                      ?.includes(value.toLowerCase());
                    return filterSearch;
                  }}
                  disabled={!property}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          <Action searchType="central" />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default SearchOverview;
